import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function AllSubjectsIllustration({
  achievementId,
  variant = 'royal',
  // Unlocks royal variant
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3579">
      <div className="relative w-full h-full bg-gradient-to-br from-indigo-900 via-purple-900 to-fuchsia-900 overflow-hidden" data-id="element-3580">
        {/* Background: Golden Mandala / Symbols */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3581">
          <g className="origin-center animate-[spin_40s_linear_infinite]" style={{
          transformOrigin: '100px 100px'
        }} data-id="element-3582">
            <circle cx="100" cy="100" r="80" stroke="#FBBF24" strokeWidth="2" strokeDasharray="10 10" opacity="0.3" data-id="element-3583" />
            <circle cx="100" cy="100" r="60" stroke="#FDE047" strokeWidth="1" opacity="0.2" data-id="element-3584" />

            {/* Abstract subject symbols arranged in a circle */}
            {[...Array(10)].map((_, i) => {
            const angle = i * 36 * (Math.PI / 180);
            const x = 100 + 70 * Math.cos(angle);
            const y = 100 + 70 * Math.sin(angle);
            return <circle key={i} cx={x} cy={y} r="6" fill="#FBBF24" opacity="0.6" data-id="element-3585" />;
          })}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[5%]" data-id="element-3586">
          <div className="w-[70%] h-[70%] flex items-center justify-center" data-id="element-3587">
            <DjaySpecimen look={{
            variant,
            accessory: 'scepter'
          }} size="hero" emotion={isUnlocked ? 'celebrating' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3588" />
          </div>
        </div>

        {/* Foreground: Royal Confetti */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3589">
            <path d="M20 40 L30 45 L25 55 Z" fill="#FDE047" data-id="element-3590" />
            <path d="M170 30 L180 35 L175 45 Z" fill="#FDE047" data-id="element-3591" />
            <path d="M40 160 L50 165 L45 175 Z" fill="#FBBF24" data-id="element-3592" />
            <path d="M160 150 L170 155 L165 165 Z" fill="#FBBF24" data-id="element-3593" />

            <circle cx="50" cy="80" r="3" fill="#A78BFA" data-id="element-3594" />
            <circle cx="150" cy="100" r="4" fill="#F472B6" data-id="element-3595" />
            <circle cx="100" cy="170" r="3" fill="#38BDF8" data-id="element-3596" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}